import restored from '../data/restored-pages.cjs';

export const citySlug = restored.slugifyCity;